// Route configurations
const options = {
  // SIDE MENU ADMIN(user_admin) & CS(user_cs)
  // VISIBLE MENU: Dashboard(All), Community(All), PMC(All), SGC(All), PDC(All), Service(All), VMS(All), Niti News Update(All), Recycling(All), Social(All), Utilities(All)
  admin: [
    {
      key: "dashboard",
      label: "sidebar.dashboardPage",
      leftIcon: "ion-grid",
    },
    {
      key: "community",
      label: "sidebar.communityPage",
      leftIcon: "ion-home",
    },
    {
      key: "pmc",
      label: "sidebar.pmcPage",
      leftIcon: "ion-briefcase",
    },
    {
      key: "sgc",
      label: "sidebar.sgcPage",
      leftIcon: "ion-alert",
    },
    {
      key: "pdc",
      label: "sidebar.pdcPage",
      leftIcon: "ion-ios-home",
    },
    {
      key: "services",
      label: "sidebar.services",
      leftIcon: "ion-android-cart",
      children: [
        {
          key: "services/transactions",
          label: "sidebar.servicesTransactions",
        },
        {
          key: "services/activitylog",
          label: "sidebar.servicesActivityLog",
        }
      ],
    },
    {
      key: "vms",
      label: "sidebar.vms",
      leftIcon: "ion-cash",
    },
    {
      key: "newsupdate",
      label: "sidebar.nitiNewsUpdate",
      leftIcon: "ion-speakerphone",
    },
    {
      key: "Recycling",
      label: "sidebar.recycling",
      leftIcon: "ion-android-sync",
    },
    {
      key: "social",
      label: "sidebar.social",
      leftIcon: "ion-ios-people",
      children: [
        {
          key: "social/reportposts",
          label: "sidebar.socialReportPost",
        },
        {
          key: "social/reportfakename",
          label: "sidebar.socialReportFakeName",
        },
        {
          key: "social/reportspamuser",
          label: "sidebar.socialReportSpamUser",
        },
        {
          key: "social/reportthreatuser",
          label: "sidebar.socialReportThreatUser",
        },
      ],
    },
    {
      key: "utilities",
      label: "sidebar.utilities",
      leftIcon: "ion-settings",
      children: [
        {
          key: "utilities/changename",
          label: "sidebar.utilitiesChangeName",
        },
        {
          key: "utilities/otp",
          label: "sidebar.utilitiesVerificationOTP",
        },
        {
          key: "utilities/forgotpassword",
          label: "sidebar.utilitiesForgotPassword",
        },
        {
          key: "utilities/nitiwebversion",
          label: "sidebar.utilitiesNitiWebVersion",
        },
        {
          key: "utilities/androidAPKList",
          label: "sidebar.utilitiesAndroidAPKList",
        },
        {
          key: "utilities/guardappfeature",
          label: "sidebar.utilitiesGuardAppFeature",
        },
      ],
    },
  ],
  // SIDE MENU FOR SALES (user_sales) & SALES CO (user_sales_co)
  // VISIBLE MENU: Dashboard(All), Community(Except> Resident, Tennat, Committee), PMC(All), SGC(All), PDC(All), VMS(All)
  sales: [
    {
      key: "dashboard",
      label: "sidebar.dashboardPage",
      leftIcon: "ion-grid",
    },
    {
      key: "community",
      label: "sidebar.communityPage",
      leftIcon: "ion-home",
    },
    {
      key: "pmc",
      label: "sidebar.pmcPage",
      leftIcon: "ion-briefcase",
    },
    {
      key: "sgc",
      label: "sidebar.sgcPage",
      leftIcon: "ion-alert",
    },
    {
      key: "pdc",
      label: "sidebar.pdcPage",
      leftIcon: "ion-ios-home",
    },
  ],
  // ROUTES FOR FINANCE and MARKETER
  // VISIBLE MENU: Service(All)
  marketer: [
    {
      key: "services",
      label: "sidebar.services",
      leftIcon: "ion-android-cart",
    },
  ],
  // ROUTES FOR FINANCE and MARKETER
  // VISIBLE MENU: Service(All)
  default: [],
};

// export default options;
export { options };
